import React from 'react';
import whatwedoimg from '../assets/images/what-we-do-img-1.jpg';
import whatwedoimg2 from '../assets/images/what-we-do-img-2.jpg';
import ourbenefit from '../assets/images/our-benefit-img.jpg';

function Payouts() {
  return (
    <>
      <div className="page-header">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">
                  Cloud Infrastructure Solutions
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Section */}
      <div className="what-we-do">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="what-we-do-content">
                <div className="section-title">
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Facing Regular Infrastructure Issues?
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    If the servers or cloud systems you're already using are experiencing frequent problems — such as downtime, slow performance, configuration errors, resource overloads, or unclear system logs — we help analyze and optimize them so everything runs smoothly, securely, and reliably without requiring major infrastructure changes.
                  </p>
                </div>

                <div className="what-we-do-btn mt-4">
                  <a href="/contact" className="btn-default">
                    Get Help
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="what-we-do-images">
                <div className="what-do-we-img-1">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg} alt="System Improvement" />
                  </figure>
                </div>
                <div className="what-do-we-img-2">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg2} alt="Problem Resolution" />
                  </figure>
                </div>
                <div className="experience-counter-box">
                  <div className="experience-counter-no">
                    <h2>
                      <span className="counter">5</span>+
                    </h2>
                  </div>
                  <div className="experience-counter-content">
                    <p>Years of technical support experience</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bulk Section */}
      <div className="our-benefit">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 order-lg-2">
              <div className="what-we-do-content">
                <div className="section-title">
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Issues with Bulk System Processing?
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    Facing errors during large data imports (Excel/CSV), partial execution, duplicate records, validation failures, or slow system performance? We analyze the workflow and optimize it to ensure faster processing, better accuracy, and a seamless operational experience.
                  </p>
                </div>

                <div className="what-we-do-btn mt-4">
                  <a href="/contact" className="btn-default">
                    Fix Bulk Issues
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-6 order-lg-1">
              <div className="our-benefit-content">
                <div className="our-benefit-img">
                  <figure className="image-anime reveal">
                    <img src={ourbenefit} alt="Bulk Process Improvement" />
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Addition / Speed Section */}
      <div className="what-we-do">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="what-we-do-content">
                <div className="section-title">
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Delays When Adding New Entries?
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    Taking too long to add new items, validation errors, or waiting periods slowing things down? We identify the root cause and suggest fixes to make the process quicker and smoother.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="what-we-do-images">
                <div className="what-do-we-img-1">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg} alt="Faster Processing" />
                  </figure>
                </div>
                <div className="what-do-we-img-2">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg2} alt="Easy Entry Management" />
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Security Section */}
      <div className="our-benefit">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 order-lg-2">
              <div className="what-we-do-content">
                <div className="section-title">
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Worried About Security & Compliance?
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    Getting alerts, dealing with disputes, or struggling to meet rules and safety standards? We assist in reducing risks and keeping everything secure within your current setup.
                  </p>
                </div>

                <div className="what-we-do-btn mt-4">
                  <a href="/contact" className="btn-default">
                    Make It Safer
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-6 order-lg-1">
              <div className="our-benefit-content">
                <div className="our-benefit-img">
                  <figure className="image-anime reveal">
                    <img src={ourbenefit} alt="Security & Safety Support" />
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Reports / Visibility Section */}
      <div className="what-we-do">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="what-we-do-content">
                <div className="section-title">
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Confused by Reports or Tracking?
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    Reports not making sense, data not matching, status unclear, or visibility issues? We help you better understand and use your existing tools for clearer insights and easier tracking.
                  </p>
                </div>

                <div className="what-we-do-btn mt-4">
                  <a href="/contact" className="btn-default">
                    Get Clear Insights
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="what-we-do-images">
                <div className="what-do-we-img-1">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg} alt="Clear Reporting" />
                  </figure>
                </div>
                <div className="what-do-we-img-2">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg2} alt="Better Visibility" />
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Payouts;